/**
 * Oppsummeringens faner og cella hver av dem spør om.
 *
 * EGEN FIL, IKKE I `SummaryPage.tsx`: rutas loader starter hentingen for fanen siden lander på, og
 * den må komme fram til den SAMME fanen uten å dra siden — kart og økonomi med — inn i hovedbunten.
 */
import { SUMMARY_TABS, type Action, type Actor, type SummaryTab } from '@tvitvi/shared';

import { allows } from '@/auth/actor';

/** What each tab needs to be allowed to open. See the route's header for why the door is wider. */
export const SUMMARY_TAB_PERMISSION = {
  logistics: 'performance:list',
  stay: 'performance:list',
  food: 'performance:list',
  economy: 'economy:read',
  /*
   * KARTET ARVER DØRA SIN FRA RUTA DEN KOM FRA — `edition:read`, og ikke `resource:list`.
   *
   * Kartet tegner scener, ressurser, vaktposter OG oppgaver på ett bilde, så å vokte det på én av
   * de fire ville stengt de tre andre for en rolle matrisen slipper inn. Argumentet sto i
   * `route-tree.ts` da kartet var en side, og det flyttet hit med fanen.
   */
  map: 'edition:read',
} as const satisfies Record<SummaryTab, Action>;

export function visibleSummaryTabs(actor: Actor | null): SummaryTab[] {
  return SUMMARY_TABS.filter((id) => allows(actor, SUMMARY_TAB_PERMISSION[id]));
}

/**
 * An unreachable tab in the URL resolves to the first one this reader MAY open rather than to an
 * error: the route deliberately does not narrow `?tab=` to the reader's permissions, because a
 * stale bookmark is not a fault. Same rule as the booking's eight faner.
 */
export function resolveSummaryTab(requested: unknown, visible: readonly SummaryTab[]): SummaryTab {
  return typeof requested === 'string' && (visible as readonly string[]).includes(requested)
    ? (requested as SummaryTab)
    : (visible[0] ?? 'logistics');
}
